import styled from "styled-components";
import Spacer from "./Spacer";
import Button from "./Button";
import useIntercom from "hooks/useIntercom";

const Wrapper = styled.div`
  background-color: var(--skye_blue);
  height: 100vh;
  width: 100vw;

  .modal {
    background: var(--primary);
    width: 430px;
    border-radius: 16px;
    text-align: center;
    padding: 48px;
    color: #fff;
  }

  .content {
    font-weight: 450;
    font-size: 16px;
    line-height: 20px;
  }

  .actions {
    gap: 12px;
  }

  .header {
    font-weight: 700;
    font-size: 18px;
  }

  @media screen and (max-width: 768px) {
    .modal {
      width: calc(100% - 24px);
    }

    .actions {
      flex-direction: column;
    }
  }
`;

const ErrorBoundary = ({ error, resetErrorBoundary }) => {
  console.log(error);
  const { openSupportChat } = useIntercom({ autoBoot: false });

  return (
    <Wrapper className={`flexRow alignCenter justifyCenter show`}>
      <div className="modal">
        <header className="header">Something went wrong!</header>
        <Spacer y={0.6} />
        <p className="content">
          Please try refreshing the page or contact support
        </p>
        <Spacer y={2.4} />
        <div className="actions flexRow">
          <Button
            text="Refresh"
            fullWidth
            bg="#ffffff"
            color="var(--primary)"
            onClick={() => window.location.reload()}
          />
          <Button
            text="Contact support"
            fullWidth
            className="secondary"
            onClick={() => openSupportChat()}
          />
        </div>
      </div>
    </Wrapper>
  );
};

export default ErrorBoundary;
